import { ChevronDown } from "lucide-react";
import { WORK } from "@/constants/testIds";

export const PortfolioSort = ({ value, onChange }) => (
  <div className="relative shrink-0 flex items-center border border-[#2A2A2A] bg-[#181818] focus-within:border-[#CCFF00] hover:border-[#555550] transition-colors">
    <label
      htmlFor="portfolio-sort"
      data-testid="work-sort-label"
      className="pl-3 text-xs text-[#888880] uppercase"
    >
      Sort:
    </label>
    <select
      id="portfolio-sort"
      data-testid={WORK.sortSelect}
      aria-label="Sort portfolio"
      value={value}
      onChange={(event) => onChange(event.target.value)}
      className="appearance-none bg-transparent min-h-[40px] w-[106px] pl-2 pr-7 text-xs text-[#CCFF00] uppercase outline-none cursor-pointer"
    >
      <option data-testid="work-sort-option-latest" value="latest" className="bg-[#181818]">LATEST</option>
      <option data-testid="work-sort-option-oldest" value="oldest" className="bg-[#181818]">OLDEST</option>
      <option data-testid="work-sort-option-featured" value="featured" className="bg-[#181818]">FEATURED</option>
    </select>
    <ChevronDown size={12} aria-hidden="true" className="pointer-events-none absolute right-2 text-[#888880]" />
  </div>
);